export const at = <T>(anyArray: Array<T> | undefined | null, idx: number): T | undefined => {
  if (!anyArray) return undefined
  if (anyArray.length === 0) return undefined

  if (idx < 0) return anyArray[anyArray.length + idx]

  return anyArray[idx]
}
